module.exports = __webpack_public_path__ + "img/close.b8a83e50.svg";